module.exports = __webpack_public_path__ + "media/images/static/benefit/h2_merit1-0b2d1ac8fdd52577e667b6ab45e9dcc2.png";